<template>
    <div class="container">
        <v-row>
            <v-col cols="11">
                <v-card-title class="titulopagina">DESPACHOS DE HARINA</v-card-title>
            </v-col>
            <v-col cols="1">
                <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                    <v-icon color="blue" large>help</v-icon>
                </v-alert>
            </v-col>
        </v-row>
        <modal-ayuda></modal-ayuda>
        <v-col cols="12">
            <v-card>
                <v-row class="ml-1 mr-1">                
                    <v-col cols="3">
                        <date-picker v-model="fecha" placeholder ="Seleccione Fecha" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            :items="turnos"
                            item-text="nombre_turno"
                            item-value="id"
                            v-model="turno"
                            label="Seleccione Turno"
                            class="float-right"
                            dense
                        ></v-select>
                    </v-col>
                </v-row>
                <!-- <v-card-text>Despacho de Harina</v-card-text> -->
            </v-card>
            <v-row class="ml-1 mr-1" v-if="alert">
                <v-col>
                    <v-alert
                        dense
                        text
                        type="success"
                    >
                    Despacho Generado Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                    </v-alert>
                </v-col>
            </v-row>
        </v-col>
       
        <v-col cols="12">
            <v-card color="white">
                <v-card-actions>
                    <v-col cols="6">
                        <v-card color="white">
                            <v-row class="ml-1 mr-1">
                                <!-- <v-col>Lote: {{this.lote?this.lote.nombre_lote:''}}</v-col> -->
                                <v-col>
                                    <v-autocomplete
                                        v-model="lote"
                                        :items="lotes"
                                        item-text="nombre_lote"
                                        item-value="id"
                                        label="Seleccione Lote"
                                        color="blue darken-3"
                                        return-object
                                        @change="cargarJumbosLote($event)"
                                        dense
                                    ></v-autocomplete>
                                </v-col>
                                <v-col class="text-center">
                                    BODEGA
                                </v-col>
                                <v-col>
                                    <v-btn class="float-right" small dark color="#1565C0" @click="agregar">
                                        <!-- <span>Asignar</span> -->
                                        <v-icon>keyboard_arrow_right</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-checkbox
                                            v-model="checkbox_select"
                                            label="Todos"
                                            color="#0288D1"
                                            class="float-right"
                                            hide-details
                                            @change="seleccionarTodos"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col v-for="j in jumbos_ordenados" :key="j.id">
                                        <v-switch v-model="j.switch" :label="`${j.nro_jumbo}`"></v-switch>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="6">
                        <v-card color="white">
                            <v-row class="ml-1 mr-1">
                                <v-col>
                                    <v-btn small dark color="#1565C0" @click="quitar">
                                        <v-icon>keyboard_arrow_left</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col>CAMIÓN</v-col>
                                <v-col class="align-end"><v-text-field dense v-model="patente" label="Patente"></v-text-field></v-col>
                                <v-col>
                                    <v-btn dark small rounded class="float-right" color="green darken-1" @click="generarDespacho">Crear</v-btn>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-row v-for="lote in lotesCamion" :key="lote.id">
                                    <v-col class="col-md-12">{{`LOTE: ${lote.nombre_lote}`}}</v-col>
                                    <v-row>
                                        <v-col v-for="j in lote.jumbos" :key="j.id">
                                            <v-switch v-model="j.switch" :label="`${j.nro_jumbo}`"></v-switch>
                                        </v-col>
                                    </v-row>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <h3>Total Kilos: {{kilos}}</h3>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-col>
    </div>
</template>
<script>
import { mapState,mapMutations } from 'vuex'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        fecha:'',
        turno:'',
        patente:'',
        lote:'',
        lotes:[],
        jumbos:[],
        turnos:[],
        jumbos_camion:[],
        checkbox_select:false,
        alert:false
    }),
    mounted(){
        this.fecha = this.moment().format('YYYY-MM-DD HH:mm');
        this.cargarJumbos();
    },
    methods:{
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Despachos de Harina`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se registran los despachos de harina realizados diariamente.`},
                {   tipo:`label`,   texto:`- En el primer recuadro se selecciona un día y un turno.`},
                {   tipo:`label`,   texto:`- En el segundo recuadro, en la sección de la izquierda, se selecciona el lote despachado, los maxisacos que se despacharon en ese despacho y, al finalizar la selección, se pulsa el botón ">" ( insert_img_help-despacho-harina_ic1.png )`},
                {   tipo:`label`,   texto:`- En el segundo recuadro, en la sección de la derecha, se debe registrar la patente del camión en el que se despachan y, a modo de información, se indica la cantidad de kilos que se están despachando. Además se puede cancelar los maxisacos seleccionados pulsando en el botón "<" ( insert_img_help-despacho-harina_ic2.png ). Al finalizar, se pulsa el botón "Crear" ( insert_img_help-despacho-harina_ic3.png ) para registrar el despacho de harina de todos los lotes y maxisacos existentes en el recuadro.`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarJumbos(){
            //this.mostrarLoading('Cargando Lotes con Maxisacos disponibles');
            this.mostrarLoading({titulo:'Cargando Lotes con Maxisacos disponibles...',color:'green'})

            let url = `${this.base_url}lotes/jumbos/disponibles`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('respuesta jumbos disponibles',res.data);
                this.lotes = res.data.data;
                this.ocultarLoading();
                this.cargarTurnos();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        async cargarJumbosLote($event){
            //this.mostrarLoading('Cargando Maxisacos...');
            this.mostrarLoading({titulo:'Cargando Maxisacos...',color:'green'})

            let url = `${this.base_url}jumbos/disponibles/${$event.id}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('respuesta jumbos disponibles',res.data);
                this.jumbos = res.data.data;
                /**quitar jumbos que ya estan en la lista del camion*/
                let jumbitos = this.jumbos.filter(j=>{
                    let idx = this.jumbos_agregados.findIndex(ju=>ju.id == j.id);
                    console.log('idx',idx);
                    return idx == -1 ? true : false;
                })
                this.jumbos = jumbitos;
                console.log('jumbitos',jumbitos);
                //this.setearJumbos(res.data.data);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async cargarTurnos(){
            //this.mostrarLoading('Cargando Turnos');
            this.mostrarLoading({titulo:'Cargando Turnos...',color:'green'})

            let url = `${this.base_url}turnos`;
            await this.axios.get(url,this.headers).then(async(res)=>{
                console.log('turnos',res.data);
                this.turnos = res.data.data;
                this.fecha = this.moment().format('YYYY-MM-DD HH:mm');
                let turno = await this.turnos.find(t=>{
                    let fecha = this.moment().format('YYYY-MM-DD');
                    t.hora_fin = t.hora_fin == '00:00:00'? '23:59:00':t.hora_fin;
                    let inicio = `${fecha} ${t.hora_inicio}`;
                    let fin = `${fecha} ${t.hora_fin}`;
                    return this.moment(this.fecha).isAfter(inicio) && this.moment(this.fecha).isBefore(fin);
                });
                console.log('turno filtro',turno);
                this.turno = turno.id;
                this.ocultarLoading();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            });
        },

        async agregar(){
            let agregar = await this.jumbos.filter(j => j.switch == true);
            let restantes = await this.jumbos.filter(j => j.switch != true);
            let index_lote = await this.lotes.findIndex(l => l.id == this.lote.id);
            this.$set(this.lotes[index_lote], 'jumbos', restantes);
            this.jumbos = restantes;
            this.jumbos_camion = this.jumbos_camion.concat(agregar);
            this.checkbox_select = false;
        },

        async quitar(){
            /**los id de los que se van a quitar */
            let ids = await this.jumbos_agregados.filter(j=>j.switch == false).map(
                j => j.id
            );
            let jumbos_quitar = this.jumbos_camion.filter( j => {
                return ids.includes(j.id);
            });
            /**seteando en falso la seleccion */
            jumbos_quitar.forEach(j => {
                j.switch = false;
            });
            /**conservar los jumbos del lote actual */
            let jumbos_lote = jumbos_quitar.filter(j => j.lotes_id == this.lote.id);
            this.jumbos = this.jumbos.concat(jumbos_lote);

            this.jumbos_camion = this.jumbos_camion.filter(j => {
                return !ids.includes(j.id);
            });
        },
        setearJumbos($event){
            this.checkbox_select = false;
        },
        async generarDespacho(){
            //this.mostrarLoading('Generando Despacho...')
            this.mostrarLoading({titulo:'Generando Despacho...',color:'green'})

            let body = {};
            body.patente = this.patente;
            body.turnos_id = this.turno;
            body.fecha = this.fecha;
            body.tipo_produccion_id = 1;
            body.kilos = this.kilos;
            let jumbos = [];
            // body.jumbos = this.jumbos_camion;
            this.jumbos_camion.forEach((j,index) => {
                jumbos.push(j.id);
            });
            body.jumbos = jumbos;
            let url = `${this.base_url}despacho_harina`;
            await this.axios.post(url,body,this.headers).then((res)=>{
                console.log('despacho creado',res.data.data);
                this.alert = true;
                this.limpiar();
                this.cargarJumbos();
                this.ocultarLoading();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            });
        },
        seleccionarTodos(){
            if(this.checkbox_select){
                this.jumbos.forEach(j => {
                    j.switch = true;
                });
            }else{
                this.jumbos.forEach(j => {
                    j.switch = false;
                });
            }
        },
        seleccionarTodosLote($event,id){
            let index = this.lotesCamion.findIndex(l=> l.id == id);
            this.jumbos_camion.forEach((j,index)=>{
                if(j.lotes_id == id){
                    this.$set(this.jumbos_camion[index],'switch',$event);
                }
            });
            console.log($event,`id ${id}`,`index:${index}`,this.jumbos_camion);
        },
        limpiar(){
            this.patente = '';
            this.lote = '';
            this.jumbos_camion = [];
            this.jumbos = [];
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed:{
        lotesCamion(){
            /**retorna el id y nombre de los lotes distintos */
            let lotes = Array.from( new Set(this.jumbos_camion.map(j=>j.lotes_id)))
                    .map(id => {
                        return{
                            id:id,
                            todos:true,
                            nombre_lote: this.lotes.find(l => l.id === id).nombre_lote,
                            jumbos: this.jumbos_camion.filter(j => j.lotes_id == id).map(
                                j => {
                                    return {
                                        id:j.id,
                                        nro_jumbo:j.nro_jumbo,
                                        lotes_id:j.lotes_id,
                                        switch:j.switch
                                    }
                                }
                            ).sort((a,b)=>a.nro_jumbo - b.nro_jumbo)
                        }
                    });
            return lotes;
        },
        jumbos_agregados(){
            let jbs = [];
            this.lotesCamion.forEach(l => {
                l.jumbos.forEach(j => {
                    jbs.push(j)
                });
            });
            return jbs;
        },
        kilos(){
            return this.jumbos_camion.reduce((suma_parcial, valor) => suma_parcial + valor.peso,0);
        },
        jumbos_ordenados(){
            return this.jumbos.sort((a, b) => a.nro_jumbo - b.nro_jumbo);
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}
</style>